import styled from 'styled-components';
import Text from 'components/Text';

const H3 = styled(Text).attrs({
	as: 'h3'
})``;

H3.defaultProps = {
	fontSize: 'h3',
	fontWeight: 'bold',
	fontFamily: 'headlines'
};

export default H3;
